import translator from '@Components/Utilities/Translator';
import RentalAndLeasePrices from '@Components/Shared/RentalAndLeasePrices';

const LowerDetailPricing = (props) => {
    return (
        <div className='other-site-data'>
            {(props.ShowPreAuctionTime && !props.ShowWholesalePriceOnly && !props.IsRY) &&
                <div className='other-site-data-section pre-at-price'>
                    <img className='auction-time' src={props.preATIcon} alt="" />
                    <div className='other-site-content'>
                    <div className='spaced-line'>{translator.translate('sandhills.tradepubwebsite.mvc.preauctiontimeprice')}: <span className='no-wrap'>{props.WholeSalePrice}</span></div>
                        <div className='spaced-line'>{translator.translate('sandhills.tradepubwebsite.mvc.toauction')}: <span className='no-wrap'>{props.PreAuctionTimeDate}</span></div>
                    </div>
                </div>}
            {(props.ShowWholeSale && !props.IsExclusiveWholeSale && !props.IsRY) &&
                <div className='other-site-data-section wholesale-price'>
                    <img className='wholesale' src={props.ftiIcon} alt="" />
                <div className='other-site-content'>{translator.translate('sandhills.crm.dscrm.wholesaleprice')}: <span className='no-wrap'>{props.WholeSalePrice}</span></div>
                </div>}
            {props.PriceGroup && props.PriceGroup.length > 0 &&
                <RentalAndLeasePrices PriceGroup={props.PriceGroup} IsRY={props.IsRY} />}
        </div>
    );
};

export default LowerDetailPricing;